// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-comments-threads-list-item .v-list__tile{display:block;min-height:72px;height:auto;align-items:flex-start;border-bottom:2px solid #f7f7f7;padding-bottom:8px;padding-top:8px}.w-comments-threads-list-item .v-list__tile::first-child{border-top:none}.w-comments-threads-list-item .v-list__tile::last-child{border-bottom:none}.w-comments-threads-list-item .v-list__tile__title{display:flex;align-items:center;font-weight:400;font-size:12px;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
